import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ItemUploadDataJSON, S3UploadJSON } from '../s3-upload.interface';
import { S3UploadService } from '../s3-upload.service';
import { HttpEventType, HttpResponse } from '@angular/common/http';

@Component({
  selector: 'zf-item-upload',
  templateUrl: './item-upload.component.html',
  styleUrls: ['./item-upload.component.scss'],
})
export class ItemUploadComponent implements OnInit {
  private _data!: ItemUploadDataJSON;
  @Input()
  set data(value: ItemUploadDataJSON) {
    this._data = value;
    if (
      value.sizeLimitMB &&
      this.calculateSizeMb(value.file.size) > value.sizeLimitMB
    ) {
      this.errorSizeMessage = `This file is too large to upload. The maximum supported file size are: ${value.sizeLimitMB} MB`;
    } else {
      this.upload();
    }
  }

  get data(): ItemUploadDataJSON {
    return this._data;
  }

  // ----------------------------------

  @Output() onUploaded: EventEmitter<any> = new EventEmitter<any>();

  // ----------------------------------

  progress: number = 0;
  imageUrl: string = '';
  errorSizeMessage: string = '';

  constructor(private uploadService: S3UploadService) {}

  ngOnInit() {}

  upload() {
    const data: S3UploadJSON = this.data;

    const token = Math.floor(Math.random() * 100000000).toString();
    const type =
      this.data.file.type === 'image/svg+xml' ? 'svg' : this.data.file.type;
    const imageFile = new File([this.data.file], this.data.file.name, {
      type: type,
    });

    this.uploadService.get(imageFile, data, token).subscribe(
      (result) => {
        this.uploadService.put(result, imageFile).subscribe(
          (event) => {
            const url = this.uploadService.process(
              imageFile,
              data,
              token
            ).urlDownload;

            if (event.type === HttpEventType.UploadProgress) {
              const percentDone = Math.round(
                (100 * event.loaded) / event.total
              );
              this.progress = percentDone;
              // console.log(`File is ${percentDone}% uploaded.`)
            } else if (event instanceof HttpResponse) {
              this.imageUrl = url;
              this.onUploaded.emit({
                status: 'success',
                url: url,
                token: this.data.token,
              });
              // console.log('File is completely uploaded!')
              // this.checkImageExist(url)
              //   .then(validUrl => {
              //     this.imageUrl = url
              //     this.urlUploaded.emit({
              //       'status': 'success',
              //       'url': url,
              //       'isFixed': this.fileUpload ? true : false
              //     })
              //     this.fileUpload = null
              //   }, err => {
              //     this.errorMsg = 'Error: Image could not be uploaded.'
              //     this.imageUrl = 'https://s3.amazonaws.com/stage.mango.template/default-image.jpg'
              //   })
            }
          },
          (err) => {
            console.log(err);
          }
        );
      },
      (err) => {
        console.log(err);
      }
    );
  }

  /**
   * Calculate size limit.
   *
   * @param size
   */
  calculateSizeMb(size: number) {
    return parseFloat((size / (1024 * 1024)).toFixed());
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes: any, decimals = 0) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    // this.files.splice(index, 1)
  }
}
